import { ArticleLanguageType, DashboardArticle } from './../models/article';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { Article, ArticleElement, ArticleFilter, ArticlePreference, ArticleTag, CreateArticle } from '../models/article';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ArticleService extends BaseService<Article> {
  constrollerName: string;
  constructor(public override http: HttpClient) {
    super(http);
    this.constrollerName = 'api/article';
  }

  getTopics(): Observable<ArticleTag[]> {
    return this.http.get<ArticleTag[]>(
      `${this.apiUrl}${this.constrollerName}/tags`
    );
  }

  getElements(): Observable<ArticleElement[]> {
    return this.http.get<ArticleElement[]>(
      `${this.apiUrl}${this.constrollerName}/elements`
    );
  }

  getArticles(articleFilter: ArticleFilter): Observable<Article[]> {
    return this.http.post<Article[]>(
      `${this.apiUrl}${this.constrollerName}/all`, articleFilter
    );
  }

  getArticleForDashboard(articleFilter: ArticleFilter): Observable<DashboardArticle[]> {
    return this.http.post<DashboardArticle[]>(
      `${this.apiUrl}${this.constrollerName}/getArticlesForDashboard`, articleFilter
    );
  }

  getAuthors(): Observable<ArticleElement[]> {
    return this.http.get<ArticleElement[]>(
      `${this.apiUrl}${this.constrollerName}/authors`
    );
  }

  getArticleByIdForPreview(articleId: number, language: ArticleLanguageType): Observable<Article> {
    return this.http.get<Article>(
      `${this.apiUrl}${this.constrollerName}/getArticleByIdForPreview/${articleId}/language/${language}`
    );
  }

  updateArticle(item: CreateArticle): Observable<Article> {
    return this.http.put<Article>(`${this.apiUrl}${this.constrollerName}`, item);
  }

  publicArticleById(articleId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}${this.constrollerName}/publishArticle/${articleId}`);
  }

  upsertPrefence(articlePrefence: ArticlePreference) {
    return this.http.post<ArticlePreference>(`${this.apiUrl}${this.constrollerName}/preference`, articlePrefence);
  }
}
